import { render, staticRenderFns } from "./LikertResponse.vue?vue&type=template&id=5f3cd125&scoped=true&"
import script from "./LikertResponse.vue?vue&type=script&lang=js&"
export * from "./LikertResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3cd125",
  null
  
)

export default component.exports